// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/utils/ExploreBlogTTTHandlers.jsx

import { API_ENDPOINTS } from '../api/api';

export const fetchBlogContent = async (limit = 30, offset = 0) => {
  const url = `${API_ENDPOINTS.BLOG_API}?offset=${offset}&limit=${limit}`;
  
  // --- DEBUG: แสดง URL ที่กำลังจะเรียกใน Console ---
  console.log(`[DEBUG] Fetching from URL: ${url}`);
  
  try {
    const response = await fetch(url, {
      method: 'GET'
    });

    if (!response.ok) {
      // --- DEBUG: แสดงข้อความ Error กรณี Network ไม่สำเร็จ ---
      console.error(`[DEBUG] Network response was not ok. Status: ${response.status} ${response.statusText}`);
      throw new Error(`Failed to fetch blog content: ${response.statusText}`);
    }

    // Clone response เพื่อให้เราอ่าน .json() ได้ และยังสามารถอ่าน .text() ได้ในภายหลังถ้าจำเป็น
    const clonedResponse = response.clone();
    const data = await response.json();

    // --- DEBUG: แสดงโครงสร้างข้อมูลดิบที่ได้รับจาก API ---
    console.log('[DEBUG] Raw API Response:', data);

    // --- เพิ่มการตรวจสอบโครงสร้างข้อมูล ---
    if (typeof data !== 'object' || data === null || !('posts' in data) || !('total_count' in data)) {
      console.error('[DEBUG] Invalid data structure received from API. Expected { posts: [], total_count: 0 }', data);
      // โยน Error เพื่อให้ catch block ทำงาน และแสดงผลเป็นตารางว่าง
      throw new Error('Invalid data structure from API');
    }

    return data;
    
  } catch (error) {
    // ตรวจสอบว่าเป็น JSON Parse Error หรือไม่
    if (error instanceof SyntaxError) {
      console.error('[DEBUG] Failed to parse JSON. The response is likely not valid JSON.');
      // ลองอ่าน response เป็น text เพื่อดูว่ามันคืออะไร (อาจเป็นหน้า HTML Error)
      const textResponse = await (error.response?.text() || Promise.resolve('Could not read text response.'));
      console.error('[DEBUG] Raw text response:', textResponse);
    }
    
    console.error('Error in fetchBlogContent:', error.message);
    throw error; // ส่งต่อ error ให้ Component จัดการ
  }
};

// ----- START: MODIFIED handleShare FUNCTION -----
export const handleShare = async ({
  message,
  statusAttachedMedia,
  shareUrl,
  selectedImageUrls,
  isScheduled,
  scheduledDate,
  scheduledTime,
  selectedPost,
  user_ID,
  toast,
  selectedBackground, // NEW: Receive background ID
  generatedModel,     // NEW: Receive model version
}) => {
  const facebookPayload = {};

  // Build Facebook payload based on share type
  if (statusAttachedMedia === 3) { // Text Only
    facebookPayload.message = message;
    // Add background preset ID if one is selected
    if (selectedBackground) {
      facebookPayload.text_format_preset_id = selectedBackground;
    }
  } else if (statusAttachedMedia === 1) { // Link URL
    facebookPayload.link = shareUrl;
    facebookPayload.message = message || '';
  } else if (statusAttachedMedia === 2) { // Multimedia
    if (selectedImageUrls.length > 0) {
      facebookPayload.urls = selectedImageUrls;
      facebookPayload.message = message || '';
    } else {
      toast.show({ 
        severity: 'warn', 
        summary: 'Warning', 
        detail: 'No images selected for Multimedia', 
        life: 3000 
      });
      throw new Error('No images selected for Multimedia');
    }
  }

  // Handle scheduling
  if (isScheduled && scheduledDate) {
    facebookPayload.scheduled_date = scheduledDate.toLocaleDateString('en-CA', { timeZone: 'Asia/Bangkok' }).replace(/\//g, '-');
    facebookPayload.scheduled_time = scheduledTime ? `${scheduledTime}:00` : null;
  } else {
    facebookPayload.scheduled_date = null;
    facebookPayload.scheduled_time = null;
  }

  // --- Step 1: Upload to Facebook ---
  const facebookResponse = await fetch(API_ENDPOINTS.FACEBOOK_UPLOAD, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(facebookPayload),
  });

  if (!facebookResponse.ok) {
    const errorText = await facebookResponse.text();
    throw new Error(`Facebook API error! status: ${facebookResponse.status}, details: ${errorText}`);
  }

  const facebookData = await facebookResponse.json();
  toast.show({ severity: 'success', summary: 'Success', detail: 'Post uploaded to Facebook', life: 3000 });

  const feedPostId = facebookData?.feed_result?.feed_post_id || null;
  if (!feedPostId) {
    console.error('Failed to retrieve feed_post_id from Facebook API response:', facebookData);
    throw new Error('Failed to retrieve feed_post_id from Facebook API response');
  }

  // --- Step 2: Insert share details into your database ---
  const token = localStorage.getItem('authToken');
  const payload = {
    id_post: feedPostId,
    id_connection: selectedPost.ID,
    title: selectedPost.post_title,
    message: message,
    name_website: 'https://blog.ttt-website.com/',
    link_URL_content: '',
    date: new Date().toISOString().split('T')[0],
    Social: 1,
    user_ID: parseInt(user_ID),
    websiteID: 3,
    status: 1,
    status_scheduled: isScheduled && scheduledDate ? 1 : 0,
    status_attached_media: statusAttachedMedia,
  };

  // Add media-specific data to payload
  if (statusAttachedMedia === 1) {
    payload.link_URL_content = shareUrl;
    payload.image_urls = [];
  } else if (statusAttachedMedia === 2) {
    payload.image_urls = selectedImageUrls;
  } else if (statusAttachedMedia === 3) {
    payload.image_urls = [];
    // Add Text-Only specific data for database insertion
    payload.background_presets = selectedBackground || null;
    payload.generated_text = message; // Always save the final message content
    if (generatedModel) {
      payload.generated_model = generatedModel;
    }
  }

  // Add scheduling data to payload
  if (isScheduled && scheduledDate) {
    const dateStr = scheduledDate.toLocaleDateString('en-CA', { timeZone: 'Asia/Bangkok' }).replace(/\//g, '-');
    payload.scheduled_date = dateStr;
    payload.scheduled_time = scheduledTime ? `${scheduledTime}:00` : '00:00:00';
  }

  const response = await fetch(API_ENDPOINTS.SHARE_INSERT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const errorTextInsert = await response.text();
    throw new Error(`Insert API error! status: ${response.status}, details: ${errorTextInsert}`);
  }

  await response.json();
  toast.show({ severity: 'success', summary: 'Success', detail: 'Post shared and details saved successfully', life: 3000 });
};
// ----- END: MODIFIED handleShare FUNCTION -----